import React, { useEffect } from "react";
import { Creators as StoreByUserActions } from "../../store/ducks/storeByUser";
import { Creators as UserActions } from "../../store/ducks/user";
import { Creators as CartActions } from "../../store/ducks/cart";
import { Creators as DomainActions } from "../../store/ducks/domain";
import { Creators as DeliveryContextActions } from "../../store/ducks/deliveryContext";
import { useDispatch, useSelector } from "react-redux";
import version from "../../config/version";

export default function OnInit() {
  const dispatch = useDispatch();
  const allowedDomain = useSelector(state => state.domain.allowedDomain);

  useEffect(() => {
    // Primeiro dispatch do boot, de proposito. O reducer aplica de forma sincrona, entao o
    // contexto persistido ja esta em pe antes de getAccountRequest disparar a heranca de
    // endereco inicial -- que so age quando o estado e INDEFINIDO.
    dispatch(DeliveryContextActions.hydrate());

    dispatch(DomainActions.getDomainRequest());
    // Só tenta restaurar a sessão se houver indicativo de sessão anterior
    if (localStorage.getItem('@ConexaoGAM:session')) {
      dispatch(UserActions.getAccountRequest());
    }
    dispatch(CartActions.getStorage());
    dispatch(CartActions.calculateAmount());

    const storageVersion = localStorage.getItem("@ConexaoGAM:version") || null;

    if (storageVersion !== version.basketVersion) {
      Object.keys(localStorage).forEach(key => {
        if (key.startsWith("@ConexaoGAM:cart")) {
          localStorage.removeItem(key);
        }
      });
      localStorage.removeItem("@ConexaoGAM:checkout");
      dispatch(CartActions.resetDefault());
      localStorage.setItem("@ConexaoGAM:version", version.basketVersion);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (allowedDomain) {
      dispatch(StoreByUserActions.checkItemsOutOfStock());
    }
  }, [allowedDomain]) //eslint-disable-line

  return <></>;
}
